export const REACT_APP_KAKAO_JAVASCRIPT_SDK_API_KEY =
    "a6ad8ade50e0b3e836930299a883d22f";
